class UchHolsterQuiz extends SorcistinoQuiz {
    renderQuickNav() {
        return '';
    }
    classMap(className) {
        return {
            "MakeAndModelScreen":MakeAndModelScreen,
            "CarryPositionScreen":CarryPositionScreen,
            "AccessoriesScreenV2":AccessoriesScreenV2,
            "ClothingStyleScreen":ClothingStyleScreen,
            "BodyTypeScreen":BodyTypeScreen,
            "CollectEmailScreen":CollectEmailScreen,
            "ResultsScreen":ResultsScreen,
            "DrawHandScreen":DrawHandScreen,
        }[className];
    }
    init(data) {
         super.init(data);
    }
    roorClasses() {
        return "page-width";
    }
    metaobjectId() {
        return "112284270847";
    }
    setupOnetimeEvents() {
        
         document.addEventListener(
            "rebuy:cart.change",event=>{
                this.dispatchEvent(
                    "rebuy:cart:changed",event.detail
                )
            }
        );       
    }
    setupEvents() {
        super.setupEvents();
    };
    rootClasses() {
        return "holster-finder-quiz page-width"
    }
    extraProductFields() {
        return `
            size: metafield(namespace:"custom",key:"holster_size") {
                key
                value
            }
            profile: metafield(namespace:"custom",key:"profile") {
                value
            }
            clipType: metafield(namespace:"custom",key:"clip_type") {
                value
            }
        `
    }
}
class UchScreen extends SorcistinoQuizScreen {
    title() {
        return this.data.title;
    }
    constructed() {
        
    }
    
    
}
class UchSelectionScreen extends SorcistinoSelectionScreen {
    title() {
        return this.data.title;
    }
    isConditionalScreen() {
        return true;
    }
    firearmHasHolstersForPosition(position) {
        let holsters = window.firearmsDB.holstersByMakeModel(this.getArbitraryScreenData("manufacturer"),this.getArbitraryScreenData("model"));
        if (holsters.length<0) {
            return false;
        }
        if (holsters.filter(holster=>holster.carryPosition==position).length<1) {
            return false;
        }
        return true;
    }
}

class MakeAndModelScreen extends UchScreen {
    
    constructed() {
        super.constructed();
        this.data.manufacturer = this.parent.getCookie("uch_make");
        this.data.model = this.parent.getCookie("uch_model");
        this.checkHolsters();
    }
    checkHolsters() {
        this.data.error = null;
        if (this.data.manufacturer && this.data.model) {
            let holsters = window.firearmsDB.holstersByMakeModel(this.data.manufacturer,this.data.model)
            if (holsters.length<1) {
                this.data.error = `${this.textFor("no_holsters_for")} ${this.data.manufacturer} ${this.data.model}`
            }
        }
    }
    renderModels() {
        if (this.data.manufacturer) {
            return `
                <label>${this.textFor("model_select_label")}</label>
                <div class="select-wrap select_manufacturer">
                    
                    <select name="model" id="selectModel">
                        <option value="">${this.textFor("model_select_option")}</option>
                        ${window.firearmsDB.models(this.data.manufacturer).map(model=>`<option value='${model.name}' ${this.data.model==model.name?'selected':''}>${model.name}</option>`).join("")}
                    </select>
                </div>
                `
        }
        return '';
    }
    canComplete() {
        let hasMakeAndModel = this.data.manufacturer && this.data.model;
        if (!hasMakeAndModel) {
            return false;
        }
        let holsters = window.firearmsDB.holstersByMakeModel(this.data.manufacturer,this.data.model);
        return holsters.length>0;
    }
    manufacturerList() {
        let manufacturers = window.firearmsDB.topManufacturers();
        
        if ((this.data.manufacturer && !manufacturers.includes(this.data.manufacturer)) || this.data.showAll) {
            manufacturers = window.firearmsDB.allManufacturers();
            this.data.showAll=true;
        }
        return manufacturers;
    }
    renderMakeOptions() {
        return `
            <option value="" ${this.data.showAll?'selected':''}>${this.textFor("manufacturer_select_option")}</option>
            ${this.manufacturerList().map(manufacturer=>`<option value="${manufacturer}" ${this.data.manufacturer==manufacturer?'selected':''}>${manufacturer}</option>`).join("")}
            ${this.data.showAll?'':`
                <optgroup label="${this.textFor("show_all_options_header")}">
                    <option value="all">${this.textFor("manufacturer_show_all_option")}</option>
                </optgroup>
            `}
        `;
    }
    content() {
        return `
            <div class="sorcistino-row">
                <div class="sorcistino-column column-half">
                    <label>${this.textFor("manufacturer_select_label")}</label>
                    <div class="select-wrap select_manufacturer">
                        
                        <select name="manufacturer" id="selectManufacturer">
                            ${this.renderMakeOptions()}
                        </select>
                    </div>
                </div>
                <div class="sorcistino-column column-half">
                    ${this.renderModels()}
                </div>
            </div>
        `
    }
    setupEvents() {

        this.DOMTarget().querySelector("#selectManufacturer").addEventListener("change",event=>{
            let value = event.target.options[event.target.selectedIndex].value;
            if (value=="all") {
                this.data.model = null;
                this.data.manufacturer = null;
                this.data.showAll = true;
            } else {
                this.parent.setCookie("uch_make",value);
                this.data.manufacturer=value;
            }
            this.data.model = null;
            this.isComplete = false;
            this.parent.deleteCookie("uch_model");
            this.render()
        });
        this.DOMTarget().querySelector("#selectModel")?.addEventListener("change",event=>{
            let value = event.target.options[event.target.selectedIndex].value;
            this.data.model=value;
            this.parent.setCookie("uch_model",value);
            this.parent.setCookie("uch_size",window.firearmsDB.firearmByMakeModel(this.data.manufacturer,this.data.model).size)
            this.checkHolsters();
            this.render()
            
        })
    }
    complete() {
        this.isComplete = true;
        this.setArbitraryScreenData("manufacturer",this.data.manufacturer);
        this.setArbitraryScreenData("model",this.data.model);
        this.setScreenData([`${this.data.manufacturer} ${this.data.model}`])
        this.parent.next()
    }

}


class CarryPositionScreen extends UchSelectionScreen {

    //firearmHasHolstersForPosition

    setupEvents() {
        
        this.DOMTarget().querySelectorAll('input[data-collect]').forEach(
            box=>box.addEventListener(
                "change",
                event=>{
                    let values = Array.from(this.DOMTarget().querySelectorAll('input:checked')).map(entry=>entry.dataset.value);
                    let position = Array.from(this.DOMTarget().querySelectorAll('input:checked')).map(entry=>entry.dataset.criterion)[0]
            
                    if (position=="unsure" || this.firearmHasHolstersForPosition(position)) {
                        this.data.error="";
                        this.DOMTarget().querySelector(".sorcistino-error").textContent = "";
                        this.setValue(values);
                        if (this.data.autoAdvance && this.data.questionType=="Single Choice") {
                            this.parent.next();
                        } else {
                            this.parent.setNext(true);
                        }
                    } else {
                        this.DOMTarget().querySelector(".sorcistino-error").textContent = `The ${this.getArbitraryScreenData("manufacturer")} ${this.getArbitraryScreenData("model")} has no holsters for ${position} carry`;
                        this.parent.setNext(false);
                    }
                }
            )
        )
    }

}


class AccessoriesScreenV2 extends UchSelectionScreen {

}

class AdditionalFeaturesScreen extends UchSelectionScreen {

}
class ClothingStyleScreen extends UchSelectionScreen {
    isConditionalScreen() {
        return true;
    }
    meetsConditions() {
        let meets = super.meetsConditions();
        if (!meets) { return meets;}

        meets = this.getConditionalCriteria("carryPosition").includes("unsure");

        if (meets) {
            return true;
        } else {
            this.setScreenData([])
        }
    }
}
class BodyTypeScreen extends UchSelectionScreen {
     isConditionalScreen() {
        return true;
    }
    meetsConditions() {
        let meets = super.meetsConditions()
        if (!meets) { return meets;}
        meets = this.getConditionalCriteria("carryPosition").includes("Shoulder") || this.getConditionalCriteria("carryPosition").includes("unsure");
        if (meets) {
            return true;
        } else {
            this.setScreenData([]);
        }
    }

}
class CollectEmailScreen extends UchScreen {
    constructed() {
        this.data.email = "";
        this.data.consent="";
        this.data.collected = sessionStorage.getItem("emailCollected")=="true";
    }
    canComplete() {
        return true;
    }
    isConditionalScreen() {
        return true;
    }
    meetsConditions() {
        return true;
        return !this.data.collected;
    }
    content() {
        return `
            <div class="sorcistino-row centered">
                <div class="sorcistino-column">
                    <label>${this.textFor("enter_email")}</label>
                    <input type="email" name="email" value="${this.data.email}" placeholder="Email Address">
                </div>
            </div>
            <div class="sorcistino-row centered email-consent">
                <div class="checkbox-wrapper email-consent">
                    <input type="checkbox" name="email_consent" value="true" id="emailConsent" ${this.data.consent=="yes"?'checked':''}>
                    <label for="emailConsent">${this.textFor("email_consent")}</label>
                </div>
            </div>
        `
    }
    setupEvents() {
        this.isComplete = false;
        /* this.DOMTarget().querySelector('[name="email"]').addEventListener("keydown",handler); */
        let consentCheckbox = this.DOMTarget().querySelector("#emailConsent");
        this.DOMTarget().querySelector('[name="email"]').addEventListener("input",(event)=>{
            if (event.target.value!="") {
                this.isComplete=false;
                consentCheckbox.checked = true;
            } else {
                consentCheckbox.checked = false;
            }
        });
    }

    complete() {
        let emailField = this.DOMTarget().querySelector('[name="email');
        this.data.email = emailField.value;
        this.data.consent = this.DOMTarget().querySelector('[name="email_consent"]').checked?"yes":"no";
        this.data.error = "";
        this.isComplete = false;
        if (this.data.email=="" && this.data.consent=="no") {
            this.isComplete=true;
            this.parent.next();
            return true;
        } else {
            if (this.data.consent=="no") {
                this.data.error = this.textFor("email_must_consent");
                this.render();
                return false;
            }
            if (this.data.email=="" || !emailField.checkValidity()) {
                this.data.error = this.textFor("invalid_email");
                
                this.render();
                return false;
            }
        }

        
        let properties = Object.keys(this.parent.screenData)
            .reduce(
                (a,key)=>{
                    let newHash = {};
                    let data = this.parent.screenData[key];
                    
                    if (data.constructor.name=="Object") {
                        if (data.value.length<1) {
                            return a;
                        }
                        newHash[data.reviewLabel] = data.value.map(
                            entry=>this.parent.data.handleLabelMap[entry]?this.parent.data.handleCriterionMap[entry]:entry
                        ).join(",");    
                    } else {
                        newHash[key] = data;
                    }
                    return {...a,...newHash}
                },
                {}
            )

        let klaviyoCompanyId = this.textFor("klayvio_customer_id");
        window.fetch(
            `https://a.klaviyo.com/client/profiles/?company_id=${klaviyoCompanyId}`,
            {
                method:"POST",
                headers: {
                    accept: 'application/vnd.api+json',
                    revision: '2025-10-15',
                    'content-type': 'application/vnd.api+json'
                },
                body:JSON.stringify({
                    data:{
                        type:"profile",
                        attributes: {
                            "email":this.data.email,
                            "properties":properties
                        }
                    }
                })
            }
        ).then(response=>{
            
            if (response.ok) {
                this.isComplete = true;
                this.parent.next()   
                sessionStorage.setItem("emailCollected","true")
            }  
        }).catch(error=>{
            this.data.error = error.message;
            this.render();
            console.error(error);
        });
    }
}
class DrawHandScreen extends UchSelectionScreen {
    isConditionalScreen() { return true;}
    meetsConditions() {
        let meets = super.meetsConditions();
        if (!meets) { return meets;}
        meets = !["Ankle","Shoulder"].includes(this.getConditionalCriterion("carryPosition"))
        if (!meets) {
            this.setScreenData([])
        }
        return meets;
    }
}
class ResultsScreen extends UchScreen {
    results() {
        this.screenData = new FinalScreenData(this.parent);
	    this.holsters = window.firearmsDB.holstersByMakeModel(
            this.screenData.getArbitrary("manufacturer"),
            this.screenData.getArbitrary("model")
        )
        
        
        let warning = null;
        let hardPass = [];
        let maybe = [];
        let final = [];
        let returnMatches = 3;
        let carryPosition = this.screenData.getCriterion("carryPosition");
        
        let holsterLineMap = {};
        let didntMatch = [];
        let allFeatures = this.screenData.optionsFor("features");
        let features = this.screenData.getCriteria("features");
        let selectedLines = [];
        this.holsters.forEach(holster=>{
            console.error(
                [
                    `${holster.title}->${holster.carryPosition}->${carryPosition}`,
                    holster
                ]
            )
            let totalMatchTypes = 0;
            let totalMatches = 0;
            let matches = [
                this.screenData.getReviewEntry("firearm")
            ]
            let score = this.screenData.getFieldWeight("firearm")+(holster.rating/100);
            if (carryPosition!="unsure") {
                if (["Shoulder","Ankle"].includes(carryPosition) && holster.carryPosition!=carryPosition) {
                    hardPass.push(holster);
                    return;
                }
                
                if (carryPosition==holster.carryPosition) {
                    score += this.screenData.getFieldWeight("carryPosition");
                    totalMatchTypes++;
                    totalMatches++;
                    matches.push(
                        this.screenData.getReviewEntry("carryPosition")
                    )
                }
                if (carryPosition!="unsure") {
                    
                    if (!holsterLineMap[holster.line]) {
                        score = score+1;
                        holsterLineMap[holster.line] = true;
                    } 
                }
            }
            
            

            features.forEach((criterion,index)=>{
                /* uuugggh ugly workaround */
                if (holster.carryPosition=="Shoulder" && criterion=="extramag") {
                    return;
                }
                totalMatchTypes++;
                
                if (holster.selectionFeatures.includes(criterion)) {
                    totalMatches++;
                    let existingMatch = matches.find(label=>label==this.screenData.getReviewLabel("features"));
                    if (existingMatch) {
                        existingMatch.value.push(this.screenData.getLabel("features",index))
                    } else {
                        matches.push(
                            this.screenData.getReviewEntry("features",index)
                        );
                    }
                    score += this.screenData.getFieldWeight("features");
                } else {
                    if (allFeatures.includes(criterion)) {
                        score-=999;
                        let matchData = this.screenData.getReviewEntry("features",index);
                        if (!didntMatch.find(match=>match.label==matchData.label)) {
                            didntMatch.push(matchData);
                        }
                    }
                    
                }
            });

            if (features.length<1) {
                if (!holster.selectionFeatures.includes("none-selected")) {
                    return;
                }
            }



            let drawHand = this.screenData.getCriterion("drawHand");
            if (drawHand!="both" && holster.options.includes("Hand")) {
                totalMatchTypes++;
                
                if (holster.variants.find(variant=>variant.options["Hand"]==drawHand && variant.available)) {
                    matches.push(
                        this.screenData.getReviewEntry("drawHand")
                    );
                    totalMatches++;
                } else {
                    let matchData = this.screenData.getReviewEntry("drawHand",0);
                    if (!didntMatch.find(match=>match.label==matchData.label)) {
                        didntMatch.push(matchData);
                    }
                    score=-867;
                    return;
                }
            } else {
                totalMatchTypes++;
                totalMatches++; 
            }
            if (!selectedLines.includes(holster.line)) {
                score+.5;
                selectedLines.push(holster.line);
            }
            holster.score = score;
            
            holster.matches = matches;
            holster.matchScore=totalMatchTypes>0?totalMatches/totalMatchTypes:1;
            final.push(holster)
        });
        
        let hardPassIds = hardPass.map(passOn=>passOn.id);
        
        let sorted = final.filter(holster=>!hardPassIds.includes(holster.id))
            .filter(holster=>holster.score>0)
            .sort((a,b)=>b.score-a.score);
            

        
        console.error(sorted)
        let top = sorted.filter(
            entry=>entry.matchScore>=1 && (entry.carryPosition==carryPosition || carryPosition=="unsure")
        ).slice(0,returnMatches);
        let topHandles = top.map(suggestion=>suggestion.handle);
        
        let suggested = [];

       
        

        switch(carryPosition) {
            case "Shoulder":

                suggested = this.parent.data.productSet.filter(product=>!product.tags.includes("Rig")).map(suggestion=>{
                    suggestion.score=1;
                    return suggestion;
                });
                
                if (!this.screenData.getCriteria("additionalFeatures").includes("ExtraMag")) {
                    suggested = suggested.filter(suggestion=>!suggestion.tags.includes("ExtraMag"));
                } else {
                    suggested.forEach(suggestion=>{
                        if (suggestion.tags.includes("ExtraMag")) {
                            suggestion.score+=1;
                        }
                    })
                }
                break;
            case "Ankle":
                break;
            case "IWB":
                suggested = sorted.filter(holster=>holster.carryPosition=="Appendix").slice(0,3);
                suggested.forEach(holster=>holster.score++);
                if (suggested.length<3) {
                    suggested.concat(
                        sorted.filter(holster=>holster.carryPosition=="IWB")
                            .filter(holster=>holster.carryPosition!="Appendix")
                            .filter(holster=>!topHandles.includes(holster.handle))
                            .slice(0,3-suggested.length)
                    )
                }
                break;
            case "Appendix":
                suggested = sorted.filter(holster=>holster.carryPosition=="IWB").slice(0,3)
                break;
            case "OWB":
                suggested = sorted.filter(holster=>holster.carryPosition=="OWB" || holster.carryPosition=="Shoulder").filter(holster=>!topHandles.includes(holster.handle)).slice(0,3);
                break;
            case "unsure":
                
                let styles = top.map(handle=>handle.style);
                suggested = sorted.filter(
                    suggestion=>!topHandles.includes(suggestion.handle)
                )
                /*
                suggested.forEach(holster=>{
                    if (!styles.includes(holster.carryPosition)) {
                        holster.score++;
                        styles.push(holster.carryPosition);
                    }
                })
                
                suggested = suggested
                    .sort((a,b)=>b.score-a.score)
                    .filter(holster=>!topHandles.includes(holster.handle))
                        .slice(0,3);
                */
               
                break;
        }
        if (!["Shoulder"].includes(carryPosition)) {
            suggested = suggested.sort((a,b)=>b.score-a.score);
        }
        let results = {
            top:top,
            suggested:suggested,
            hasPerfectMatches:top.find(suggestion=>suggestion?.matchScore>=1)!=null,
            didntMatch:didntMatch
        };
        
        console.error(results)
        
        return results;
    }
    holsterVariantOptions(holster) {
        
        if (holster.carryPosition=="Shoulder" || holster.productType=="Attachment") {
            let variantId = null;
            let selector = holster;
            let matchColor = false;
            if ( holster.productType!="Attachment") {
                selector = this.parent.data.productSet.find(product=>product.tags.includes("Rig"));
                matchColor = true;
            }
            
            let bodyType = this.screenData.getScalar("build");
            let selectedVariants = [];
            let selectedVariantId = null;

            
            
            switch(bodyType) {
                case "slim-athletic":
                    selectedVariants = selector.variants.filter(variant=>variant.title.toLowerCase().includes("small"));        
                    break;
                case "average":
                    selectedVariants = selector.variants.filter(variant=>variant.title.toLowerCase().includes("medium"));
                    break;
                case "big-fuller-build":
                    selectedVariants = selector.variants.filter(variant=>variant.title.toLowerCase().includes("xl"));
                    if (selectedVariants.length<1) {
                        selectedVariants = selector.variants.filter(variant=>variant.title.toLowerCase().includes("x-large"));
                    }
                    break;
            }

            selectedVariants=JSON.parse(JSON.stringify(selectedVariants));
            if (selectedVariants.length<1) {
                selectedVariants = selector.variants;
            } else {
                selectedVariants.forEach(variant=>{
                    variant.title = Object.values(variant.options).join(" / ");
                    if (variant.options["Color"]) {
                        variant.title = variant.options["Color"];
                    }
                });
            }

            return `
                <div class="select-wrap select_manufacturer">
                    <select name="variantId" data-for="${holster.handle}">
                        ${holster.variants.filter(variant=>variant.available)
                            .map(
                                variant=>`
                                <option value="${variant.id}" data-price="${variant.price}">
                                    ${variant.title}
                                </option>`
                            )
                        .join("")}
                    </select>
                </div>
                ${holster.productType=="Attachment"?'':`
                <div class="options-intercrural">Select a rig</div>
                <div class="select-wrap select_manufacturer">
                    <select name="variantId" data-for="${holster.handle}" >
                        <option value="" data-price="0.0">${this.textFor("no_rig_needed")}</option>
                            ${selectedVariants.filter(variant=>variant.available)
                            .map(
                                variant=>`
                                    <option value="${variant.id}" data-price="${variant.price}" ${variant.id==selectedVariantId?'selected':''}>
                                        ${variant.title}
                                    </option>`
                                )
                        .join("")}
                    </select>
                </div>`}
            `
            
        } else {
            let selectedVariants = holster.variants;
            
            let drawHand = this.screenData.getCriterion("drawHand");
            if (holster.options.includes("Hand") && drawHand!="both") {
                selectedVariants = selectedVariants.filter(variant=>variant.options["Hand"]==drawHand);
            }
            return `
                <div class="select-wrap select_manufacturer">
                    <select name="variantId" data-for="${holster.handle}">
                    ${selectedVariants.filter(variant=>variant.available)
                        .map(variant=>`<option value="${variant.id}" data-price="${variant.price}">${Object.values(variant.options).join(" / ")}</option>`)
                        .join("")
                    }
                    </select>
                </div>
            `
        }
    }
    holsterButtons(holster) {
            return `
                <button data-handle="${holster.handle}" class="button atc-button">
                    <span class="add-button-text">${this.textFor("add_to_cart")}</span>
                    <span class="in-cart-button-text">${this.textFor("item_in_cart")}</span>
                    <span class="adding-button-text">${this.textFor("adding_to_cart")}</span>
                </button>
            `
    }
    updatePrices(handle) {
        let form = document.querySelector(`[data-handle="${handle}"]`);
        if (!form) {
            return;
        }
        let price = 0.0;
        
        form.querySelectorAll("select").forEach(
            select=>{
                let selectedOption = select.options[select.selectedIndex];
        
                price+=parseFloat(selectedOption.dataset.price)
            }
        );
        
        document.querySelector(`[data-price-for="${handle}"]`).textContent=YWM.formatMoney(price);
    }
    renderMatches(holster) {
        if (holster.productType=="Attachment") {
            return `
                <ul>
                    <li>Firearm: ${this.screenData.getArbitrary("manufacturer")} ${this.screenData.getArbitrary("model")}</li>
                    <li>Holster: Signature ${holster.tags.includes("Shoulder")?'Shoulder':'Ankle'} Holster</li>
                </ul>
            `  
        } else {
            return `
                <ul>
                    ${holster.matches.map(
                        match=>`<li>${match.label}: ${match.value}</li>`
                    ).join("")}
                </ul>
            `
        }
    }
    renderProductGriditem(holster,variantIds) {
        return `
            <div class="holster-result" data-handle="${holster.handle}" data-id="${holster.id}">
                    <div class="product-image">
                        <img src="${holster.image}" alt="${holster.title}">
                    </div>
                    <div class="holster-details">
                        
                        <div class="holsterName">
                           ${holster.title}
                        </div>
                        <div class="holsterLink">
                            <a href="/products/${holster.handle}" data-handle="${holster.handle}" data-holster-info target="_blank">${this.textFor("more_information")}</a>
                        </div>
                        <div style="flex-grow:1;"></div>                    
                        <div class="options">
                            <form data-for="${holster.id}" data-handle="${holster.handle}">
                                ${this.holsterVariantOptions(holster)}
                            </form>
                        </div>
                    </div>
                    <div class="holster-side">
                        ${holster.matchScore<1?'':'<div class="perfectMatch">★ Perfect Match!</div>'}
                        <div class="matches">
                            ${this.renderMatches(holster)}
                        </div>
                        <div style="flex-grow:1;"></div>
                        <div data-price-for="${holster.handle}">${YWM.formatMoney(parseFloat(holster.variants[0].price))}</div>
                        <div class="buttons">
                            ${this.holsterButtons(holster)}
                        </div>
                    </div>
            </div>
        `;
    }
    suggestionsText(results) {
        if (!results.hasPerfectMatches) {
            return this.textFor("no_perfect_matches");
        } else if (this.screenData.getCriterion("carryPosition")=="Shoulder") {
            return this.textFor("shoulder_also_purchased");
        } else {
            return this.textFor("holster_alternatives");
        }
    }
    content() {
       
        let results = this.results();
        
        return `
            <div class="holster-results main">
            ${results.hasPerfectMatches?`
                ${results.top?.map(holster=>`
                        ${this.renderProductGriditem(holster)}
                    `
                ).join("")}
            </div>`:`
                    <div>${this.textFor("combination_excluded")}</div>
                    <ul>${results.didntMatch.map(
                            match=>`<li>${match.label}: ${match.value} (<a href="#" data-screen="${match.screen}">change</a>)</li>`
                        ).join("")}
                    </ul>
                    `
                }
            ${results.suggested.length>0?`
                <div class="holster-results-header alternatives">${this.suggestionsText(results)}</div>
                
                <div class="holster-results alternatives">
                    ${results.suggested?.map(holster=>`
                        ${this.renderProductGriditem(holster)}
                    `
                    ).join("")}
                </div>
            `:''}
        `
    }
    postamble() {
        return `<a href="#" class="might-be-wrong">${this.textFor("start_over")}</a>`
    }

    setupEvents() {
        super.setupEvents();
        this.DOMTarget().querySelectorAll(".holster-button").forEach(shoulder=>shoulder.addEventListener("click",event=>window.open(shoulder.dataset.url,"_blank")));
        this.DOMTarget().querySelector(".might-be-wrong").addEventListener("click",event=>{
            event.preventDefault();
            event.stopPropagation();
            this.parent.show(0);
        })
        this.DOMTarget().querySelectorAll(".holster-result").forEach(result=>this.updatePrices(result.dataset.handle));
        this.DOMTarget().querySelectorAll("select[data-for]").forEach(
            select=>select.addEventListener("change",event=>this.updatePrices(select.dataset.for))
        )
        this.DOMTarget().querySelectorAll("[data-holster-info]").forEach(
            link=>{
                console.error(link)
                link.addEventListener(
                    "click",
                    event=>{
                        event.preventDefault();
                        event.stopPropagation();
                        let variantSelector = this.DOMTarget().querySelector(`[data-for="${event.target.dataset.handle}"]`);
                        if (variantSelector!=null) {
                            window.open(
                                `/products/${event.target.dataset.handle}?variant=${variantSelector.options[variantSelector.selectedIndex].value}`,
                                "_blank"

                            );
                        } else {
                            window.open(
                                `/products/${event.target.dataset.handle}`,
                                "_blank"

                            )
                        }
                    }
                )
            }
        )

        
        this.DOMTarget().querySelectorAll(".atc-button").forEach(button=>button.addEventListener("click",event=>{
            let form = document.querySelector(`form[data-handle="${button.dataset.handle}"]`);
            let formData = new FormData(form);
            let result = document.querySelector(`.holster-result[data-handle="${button.dataset.handle}"]`);
            result.classList.add("adding");

            let variantSelector = result.querySelector("select");
            let selectedVariantId = variantSelector.options[variantSelector.selectedIndex].value;
            let holster = this.holsters.find(
                holster=>holster.variants.map(
                    variant=>variant.id
                ).includes(selectedVariantId)
            );
            let cartAttributes = Rebuy.Cart.cart.attributes;
            cartAttributes[this.textFor("cart_attributes_key")] = this.textFor("cart_attributes_value");
            let payload = {
                "attributes":cartAttributes,
                "items":formData.getAll("variantId").filter(variantId=>variantId!="").map(variantId=>{
                    let itemData = {
                        "id":variantId,
                        "quantity":1,
                    };
                    if (variantId==selectedVariantId) {
                            itemData.properties = {
                                "Make":this.parent.screenData.manufacturer,
                                "Model":this.parent.screenData.model,
                                "Holster Size":holster.size
                            }
                    }
                    return itemData;
                }).reverse()
            };
            try {
                window.fetch(
                    "/cart/add.js",
                    {
                        method:"POST",
                        headers:{
                            "Content-Type":"application/json",
                        },
                        "credentials":"include",
                        body:JSON.stringify(payload),
                    }
                ).then(response=>response.json()).then(json=>{
                        if (json.status==422) {
                            alert(json.message);
                            result.classList.remove("adding")
                        }
                 }
                );
                /*
                let res = Rebuy.Cart.addItem(
                    payload,
                    {
                        "Make":this.parent.screenData.manufacturer,
                        "Model":this.parent.screenData.model,
                        "Retention Type":holster.retentionType||"",
                        "Holster Size":holster.size
                    }
                );
                console.error(e.constructor.name)
            */
            } catch(e) {
                console.error(e)
            }
            // result.classList.add("in-cart")
        }));
        Rebuy.Cart.getItems().forEach(cartItem=>this.DOMTarget().querySelector(`.holster-result[data-id="${cartItem.product_id}"]`)?.classList.add("in-cart"));
        this.parent.EventTarget().addEventListener(
            "rebuy:cart:changed",
            event=>{
                
                let cartItems = Rebuy.Cart.getItems();
                
                this.DOMTarget().querySelectorAll(".holster-result").forEach(holster=>{
                    holster.classList.remove("adding")
                    if (cartItems.find(cartItem=>cartItem.product_id.toString()==holster.dataset.id)) {
                        holster.classList.add("in-cart");
                    } else {
                        holster.classList.remove("in-cart");
                    }
                
                }
            );
        });
    }

    
}   
